import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL;

export default function SuperAdminEmpresas() {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState('');
  const navigate                = useNavigate();
  const token                   = localStorage.getItem('sa_token');

  useEffect(() => {
    if (!token) { navigate('/superadmin/login'); return; }
    fetch(`${API}/superadmin/empresas`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => { if (r.status === 401) { navigate('/superadmin/login'); throw new Error(); } return r.json(); })
      .then(setEmpresas)
      .catch(() => setError('No se pudieron cargar las empresas.'))
      .finally(() => setLoading(false));
  }, []);  // eslint-disable-line

  const logout = () => { localStorage.removeItem('sa_token'); navigate('/superadmin/login'); };

  return (
    <div style={styles.bg}>
      <div style={styles.topbar}>
        <div><span style={styles.brand}>TURNORA</span><span style={styles.badge}>SUPERADMIN</span></div>
        <button onClick={logout} style={styles.logoutBtn}>Cerrar sesión</button>
      </div>

      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={styles.h2}>Empresas con suscripción</h2>

          {loading && <p style={styles.muted}>Cargando…</p>}
          {error   && <p style={styles.errorMsg}>{error}</p>}

          {!loading && !error && empresas.length === 0 && (
            <p style={styles.muted}>No hay empresas con Stripe vinculado.</p>
          )}

          {empresas.length > 0 && (
            <table style={styles.table}>
              <thead>
                <tr>
                  {['Empresa', 'CIF', 'Email', ''].map(h => (
                    <th key={h} style={styles.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {empresas.map(e => (
                  <tr key={e.id} style={styles.tr}>
                    <td style={styles.td}><strong>{e.nombre_fiscal}</strong></td>
                    <td style={styles.td}>{e.cif || '—'}</td>
                    <td style={styles.td}>{e.email || '—'}</td>
                    <td style={styles.td}>
                      <button
                        style={styles.btnPrimary}
                        onClick={() => navigate(`/superadmin/empresas/${e.id}/facturas`)}
                      >
                        Ver facturas
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  bg:         { minHeight: '100vh', background: '#f1f5f9', fontFamily: "'Segoe UI', Arial, sans-serif", fontSize: 14 },
  topbar:     { background: '#0f172a', color: '#fff', padding: '0 32px', height: 52, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  brand:      { fontSize: 16, fontWeight: 700, color: '#FF7A00', letterSpacing: .5 },
  badge:      { fontSize: 11, background: '#FF7A00', color: '#fff', padding: '2px 8px', borderRadius: 4, marginLeft: 10 },
  logoutBtn:  { background: 'transparent', border: '1px solid #475569', color: '#94a3b8', padding: '4px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 12 },
  container:  { maxWidth: 960, margin: '36px auto', padding: '0 20px' },
  card:       { background: '#fff', borderRadius: 10, boxShadow: '0 1px 4px rgba(0,0,0,.08)', padding: '28px 32px' },
  h2:         { fontSize: 17, fontWeight: 700, marginBottom: 18, color: '#0f172a' },
  muted:      { color: '#94a3b8', fontSize: 13, padding: '20px 0', textAlign: 'center' },
  errorMsg:   { color: '#b91c1c', background: '#fee2e2', padding: '10px 16px', borderRadius: 6, fontSize: 13 },
  table:      { width: '100%', borderCollapse: 'collapse' },
  th:         { textAlign: 'left', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: .6, color: '#64748b', padding: '8px 12px', borderBottom: '2px solid #f1f5f9' },
  tr:         {},
  td:         { padding: '11px 12px', borderBottom: '1px solid #f8fafc', fontSize: 13, verticalAlign: 'middle' },
  btnPrimary: { background: '#FF7A00', color: '#fff', border: 'none', padding: '6px 16px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' },
};
